var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.page.frequencies,"item-text":"name","item-value":"id","label":"Fréquence","outlined":"","hide-details":""},model:{value:(_vm.frequency),callback:function ($$v) {_vm.frequency=$$v},expression:"frequency"}})}
var staticRenderFns = []

export { render, staticRenderFns }